import prettier from 'prettier/standalone';
import plugins from 'prettier/parser-babylon';
import { removeUnprintableChar } from '../utils';
export class JSFormatter {
    getFormatted(rawText, options = JSFormatter.defaultOptions) {
        let t = rawText;
        try {
            t = prettier.format(rawText, options);
        }
        catch (error) {
            // 
        }
        return t;
    }
    getRaw(formattedText) {
        return removeUnprintableChar(formattedText);
    }
}
JSFormatter.defaultOptions = { parser: 'babel', plugins: [plugins] };
export default new JSFormatter();
